let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iVZbQ")).then(() => parcelRequire('45LbL'));